import { logger } from '../../../utils/logger';
import { getContactService, getVoiceControlService } from './service-getters';

export async function answerCall(contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Answering call:', contactId);
  const service = getContactService();
  await service.acceptContact(contactId);
}

export async function rejectCall(contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Rejecting call:', contactId);
  const service = getContactService();
  await service.rejectContact(contactId);
}

export async function holdCall(contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Holding call:', contactId);
  try {
    const service = getVoiceControlService();
    await service.holdContact(contactId);
    logger.debug('[CXone SDK] Hold call succeeded');
  } catch (error) {
    logger.error('[CXone SDK] Hold call failed:', error);
    throw error;
  }
}

export async function resumeCall(contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Resuming call:', contactId);
  try {
    const service = getVoiceControlService();
    await service.resumeContact(contactId);
    logger.debug('[CXone SDK] Resume call succeeded');
  } catch (error) {
    logger.error('[CXone SDK] Resume call failed:', error);
    throw error;
  }
}

export async function muteCall(_contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Muting agent');
  try {
    const service = getVoiceControlService();
    await service.muteAgent();
    logger.debug('[CXone SDK] Mute call succeeded');
  } catch (error) {
    logger.error('[CXone SDK] Mute call failed:', error);
    throw error;
  }
}

export async function unmuteCall(_contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Unmuting agent');
  try {
    const service = getVoiceControlService();
    await service.unmuteAgent();
    logger.debug('[CXone SDK] Unmute call succeeded');
  } catch (error) {
    logger.error('[CXone SDK] Unmute call failed:', error);
    throw error;
  }
}

export async function endCall(contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Ending call:', contactId);
  try {
    const service = getVoiceControlService();
    await service.endContact(contactId);
    logger.debug('[CXone SDK] End call succeeded');
  } catch (error) {
    logger.error('[CXone SDK] End call failed:', error);
    throw error;
  }
}
